import { inject, Component, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { MatIconModule } from '@angular/material/icon';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { InrFormatPipe } from '@pipes/inr-format/inr-format.pipe';
import { CurrencyIconComponent } from '@core-components/currency-icon/currency-icon.component';

@Component({
  selector: 'app-thankyou-success-head',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    InrFormatPipe,
    CurrencyIconComponent,
    MatIconModule,
    ComponentLoader
  ],
  templateUrl: './thankyou-success-head.component.html',
  styleUrls: ['./thankyou-success-head.component.scss']
})
export class ThankyouSuccessHeadComponent {

  public util = inject(UtilService);
  public vars = inject(VariablesService);

  @Input() config;
  isMobile = this.vars.isMobile;
  userData;
  pan_updated = false;

  ngOnInit() {
    this.vars.userData.subscribe(user => {
      this.userData = user;
    });
  }

  panUpdateToggle = (e) => {
    this.pan_updated = e;
  }

}
